import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import Sidebar from "../sidebar/Sidebar";
import styles from "./css/Home.module.scss";

const Home = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 768);

  // Function to toggle the sidebar open/closed state
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      const isLargeScreen = window.innerWidth > 768;
      setIsSidebarOpen(isLargeScreen);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={`${styles.container}`}>
      <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className={`${styles.content_div}`}>
        <Navbar toggleSidebar={toggleSidebar} />
        <div className={`${styles.content}`}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Home;
